import { render, staticRenderFns } from "./salInsuredList.vue?vue&type=template&id=01b1b6fe&scoped=true&"
import script from "./salInsuredList.vue?vue&type=script&lang=js&"
export * from "./salInsuredList.vue?vue&type=script&lang=js&"
import style0 from "./salInsuredList.vue?vue&type=style&index=0&id=01b1b6fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1b6fe",
  null
  
)

export default component.exports